import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { InfoCertificatoDTO } from "@app/shared/dto/protocollo/info-certificatoDTO";
import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";
 

@Injectable({
    providedIn: "root"
})
export class MapperInfoCertificato implements MapperInterface<InfoCertificatoDTO, InfoCertificatoVO> {
 
    convertVoToDto(t: InfoCertificatoVO): InfoCertificatoDTO {
         let infoCertificatoDTO = new InfoCertificatoDTO();

        infoCertificatoDTO.givenName = t.givenName;
        infoCertificatoDTO.identifier = t.identifier;
        infoCertificatoDTO.signer = t.signer;
        infoCertificatoDTO.subjectOrganization = t.subjectOrganization;
        infoCertificatoDTO.caOrganization = t.caOrganization;
        infoCertificatoDTO.surname = t.surname;
        infoCertificatoDTO.notAfter = t.notAfter;
        infoCertificatoDTO.notBefore = t.notBefore;
        
        return infoCertificatoDTO || new InfoCertificatoDTO();

    }
    convertDtoToVo(t: InfoCertificatoDTO): InfoCertificatoVO {

        let infoCertificatoVO = new InfoCertificatoVO();

        infoCertificatoVO.givenName = t.givenName;
        infoCertificatoVO.signer = t.signer;
        infoCertificatoVO.identifier = t.identifier;
        infoCertificatoVO.subjectOrganization = t.subjectOrganization;
        infoCertificatoVO.caOrganization = t.caOrganization;
        infoCertificatoVO.surname = t.surname;
        infoCertificatoVO.notAfter = t.notAfter;
        infoCertificatoVO.notBefore = t.notBefore;
        
        return infoCertificatoVO || new InfoCertificatoVO();

    }
    convertListVoToDto(e: InfoCertificatoVO[]): InfoCertificatoDTO[] {
        throw new Error('Method not implemented.');
    }
    convertListDtoToVo(t: InfoCertificatoDTO[]): InfoCertificatoVO[] {
        throw new Error('Method not implemented.');
    }

   
}